import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { onSignIn, selectUser, setExport, signInFromCookie } from "../../store/slices/auth";
import { externalLoginUrl } from "../../constants/api";
import { getSsoLoginCookie } from "../../utils/ssoCookie";

type Props = {
  children: React.ReactNode;
};

const PrivateRoute: React.FC<Props> = ({ children }) => {
  const dispatch = useDispatch();
  const gambod = localStorage.getItem("gambod");
  const exportEnabled = localStorage.getItem("export");
  const user = useSelector(selectUser);
  const [cookieLoginStatus, setCookieLoginStatus] = useState<"idle" | "in_progress" | "done">("idle");
  const ssoCookie = getSsoLoginCookie();
  useEffect(() => {
    if (gambod) {
      const data = JSON.parse(gambod);
      dispatch(
        onSignIn({
          token: data.token,
          user: data.user,
        }),
      );
    }
  }, [dispatch, gambod]);

  // If we don't yet have a GAMBoD session but we do have a WordPress
  // login cookie from the external GSA site, attempt to sign in from cookie.
  useEffect(() => {
    const tryCookieLogin = async () => {
      if (!gambod && ssoCookie && cookieLoginStatus === "idle") {
        setCookieLoginStatus("in_progress");
        try {
          await dispatch<any>(signInFromCookie({ cookie: ssoCookie }));
        } catch (error) {
          // If this fails we'll fall back to redirecting to external login below.
          // eslint-disable-next-line no-console
          console.error("Cookie-based SSO login failed", error);
        } finally {
          setCookieLoginStatus("done");
        }
      }
    };

    tryCookieLogin();
  }, [dispatch, gambod, ssoCookie, cookieLoginStatus]);

  useEffect(() => {
    if (exportEnabled) {
      try {
        dispatch(setExport(JSON.parse(exportEnabled)));
      } catch (error) {
        console.error("Error parsing export", error);
      }
    }
  }, [dispatch, exportEnabled]);

  if (!gambod) {
    // If we have a WordPress login cookie and we haven't completed
    // (or failed) a cookie-based login attempt yet, wait for that
    // process to finish instead of redirecting immediately.
    if (ssoCookie && cookieLoginStatus !== "done") {
      return null;
    }

    // No GAMBoD session and either no WordPress cookie or cookie-based
    // login has already been attempted and did not establish a session:
    // send user to the external GSA login, which will redirect back
    // to the GAMBoD staging dashboard after successful login.
    window.location.href = externalLoginUrl;
    return null;
  }

  return <>{user && children}</>;
};

export default PrivateRoute;
